import type { GetForecastGraphRequest, GetForecastGraphResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const getForecastGraph = sendRequest<GetForecastGraphRequest, GetForecastGraphResponse>({
  url: '/forecast_graph',
  method: 'get',
});
